"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var date_picker_1 = require("@csod/date-picker");
exports.DatePicker = date_picker_1.default;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["DatePicker"] = [];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/DatePicker/DatePicker.js
// module id = 225
// module chunks = 0 1